import React from 'react';

import { LazyTeamCalendars, CALENDAR_CONTEXT } from '@confluence/team-calendar';

export function MyCalendarRoute() {
	return <LazyTeamCalendars calendarContext={CALENDAR_CONTEXT.MY_CALENDARS} />;
}

MyCalendarRoute.NAVIGATION_PARAMS = ({ spaceKey }) => ({
	Screen: {
		screenEvent: {
			name: 'myCalendarsScreen',
			id: spaceKey,
		},
		pageState: { spaceKey },
	},

	MainLayout: {
		spaceKey,
	},
});
